export const isValidName = (string) => {
  return RegExp(/^[a-z )(,.'-/]+$/i).test(string);
};
